import React from 'react';
import { BubbleView, BubbleTip } from './styles';

/**
 * Message bubble
 *
 * @param props - Render props
 */
export function Bubble(props: BubbleProps) {
  const { children, showTip = false, height } = props;

  return (
    <BubbleView height={height}>
      {showTip && <BubbleTip />}
      {children}
    </BubbleView>
  );
}
export interface BubbleProps {
  /** Children nodes to render */
  children: React.ReactNode;
  /** Show a tip on top of a chat message */
  showTip?: boolean;
  /** optional height for the bubble component */
  height?: number;
}
